module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/arrow_next-24c328f49fc1101df2d6e6e93fe18d28.svg";